import { render, staticRenderFns } from "./LinhaDeItemDetalhes.vue?vue&type=template&id=040c8053&scoped=true"
import script from "./LinhaDeItemDetalhes.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeItemDetalhes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeItemDetalhes.vue?vue&type=style&index=0&id=040c8053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c8053",
  null
  
)

export default component.exports